<template>
  <div :class="$style.container"
       id="institutions"
       style="height: 100%"
       v-loading.fullscreen.lock.body="loading"
       element-loading-text="拼命加载中"
       element-loading-spinner="el-icon-loading"
       element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <el-row style="border-bottom:2px dotted #e7eaec;padding-bottom: 10px;">
      <el-col :span="20" style="font-weight: bold;line-height: 36px;font-size: 22px">
        登录日志
      </el-col>
      <el-col :span="4">

      </el-col>
    </el-row>
    <el-row style="border-bottom: 2px dotted rgb(231, 234, 236)">
      <el-row style="margin-top:20px;">
        <el-col :span="12">
          <el-form ref="form">
            <el-form-item>
             <span style="font-weight: bold;display: inline-block;width: 70px;margin-right: 10px">
                                    登录人</span>
              <el-input v-model="username" placeholder="请输入登录人" style="width:calc(100% - 120px)"></el-input>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="12">
          <el-form ref="form">
            <el-form-item>
             <span style="font-weight: bold;display: inline-block;width: 70px;margin-right: 10px">
                                    登录设备</span>
              <el-input v-model="device_type" placeholder="请输入登录设备"
                        style="width:calc(100% - 120px)"></el-input>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form ref="form">
            <el-form-item>
             <span style="font-weight: bold;display: inline-block;width: 70px;margin-right: 10px">
                                    设备系统</span>
              <el-input v-model="device_os" placeholder="请输入设备系统"
                        style="width:calc(100% - 120px)"></el-input>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="12">
          <el-form ref="form">
            <el-form-item>
             <span style="font-weight: bold;display: inline-block;width: 70px;margin-right: 10px">
                                    系统版本</span>
              <el-input v-model="os_version" placeholder="请输入系统版本" style="width:calc(100% - 120px)"></el-input>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form ref="form">
            <el-form-item>
             <span style="font-weight: bold;display: inline-block;width: 70px;margin-right: 10px">
                                    浏览器</span>
              <el-input v-model="browser_name" placeholder="请输入浏览器"
                        style="width:calc(100% - 120px)"></el-input>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <el-row style="margin-bottom:20px;">
        <el-button type="primary" size="small" @click.stop="handleQueryClick">查询</el-button>
        <el-button type="danger" size="small" @click.stop="eventReset">重置</el-button>
      </el-row>
    </el-row>
    <el-table
        :data="tableData"
        :header-cell-style="{'color':'black','font-size':'15px'}"
        border
        style="width: 100%;margin-top: 20px"
        stripe>
      <el-table-column
          fixed
          align="center"
          type="index"
          label="序号"
          width="60">
      </el-table-column>
      <el-table-column
          min-width="200"
          prop="username"
          sortable
          label="登录人">
      </el-table-column>
      <el-table-column
          min-width="200"
          prop="device_type"
          sortable
          label="登录设备">
      </el-table-column>
      <el-table-column
          min-width="200"
          prop="device_os"
          sortable
          label="设备系统">
      </el-table-column>
      <el-table-column
          min-width="200"
          prop="os_version"
          sortable
          label="系统版本">
      </el-table-column>
      <el-table-column
          min-width="200"
          prop="browser_name"
          sortable
          label="浏览器">
      </el-table-column>
      <el-table-column
          min-width="200"
          prop="timestamp"
          sortable
          label="登录时间">
      </el-table-column>
    </el-table>
    <el-col style="margin-bottom: 20px">
      <pagination :page="page" @changePage="changePageClick"></pagination>
    </el-col>
  </div>
</template>

<script>
import http from '../../../APIService/http'
import pagination from '../../../components/pagination'
import 'quill/dist/quill.snow.css'
import * as Quill from 'quill' //引入编辑器
import moment from 'moment'
import Video from './video.js'

Quill.register(Video, true)

export default {
  data () {
    return {
      username: '',
      device_type: '',
      device_os: '',
      os_version: '',
      browser_name: '',
      tableData: [],
      loading: false,
      page: {
        current: 1,
        size: 5,
        total: 0,
      },
    }
  },
  name: 'index',
  components: {
    pagination,
  },
  created () {
    this.getUserLogsList('', '', '', '', '', true)
  },
  methods: {
    // 改变页码信息
    changePageClick (page, size) {
      if (page) {
        this.page.current = page
      }
      if (size) {
        this.page.size = size
      }
      this.getUserLogsList(this.username, this.device_type, this.device_os, this.os_version, this.browser_name, false)
    },
    handleQueryClick () {
      this.getUserLogsList(this.username, this.device_type, this.device_os, this.os_version, this.browser_name, true)
    },
    eventReset () {
      this.username = ''
      this.device_type = ''
      this.device_os = ''
      this.os_version = ''
      this.browser_name = ''
    },
    async getUserLogsList (username, device_type, device_os, os_version, browser_name, is) {
      let loading = this.$loading({
        lock: true,
        text: '拼命加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })

      if (is) {
        this.page.current = 1
      }

      try {
        let user = this.$store.getters.getUser
        let params = {
          tenant_id: user.tenant_id,
          username: username,
          device_type: device_type,
          device_os: device_os,
          os_version: os_version,
          browser_name: browser_name,
          offset: this.page.size,
          page: this.page.current - 1,
        }
        debugger
        await http.post('/wapi/log/getUserLogsList', params).then((res) => {
          debugger
          if (res.success) {
            this.tableData = res.data
            this.page.total = Number(res.allCount)
            console.log(this.page.total)
          }
          loading.close()
        })
      } catch (e) {
        loading.close()
        console.log(e)
        debugger
        return e
      }
    },
  }
}
</script>

<style lang="scss" module>
.el-container {
  padding: 20px;
  background: white;
  height: 100%;
}

#jurisdictionActive {
  background: white;
}

#jurisdictionActive .el-main {
  background: white;
}

.el-main {
  background: white;
  /*border: 1px solid #DCDFE6;*/
  border-left: none;
  padding: 20px 20px;
  padding-bottom: 20px;
  box-sizing: border-box;
}

/*输入框背景*/
#productSku .sWei .el-input__inner {
  background: #eee;
}
</style>



// WEBPACK FOOTER //
// src/pages/system/components/logtab.vue